import { useEffect } from 'react';

import store from 'store';

import useModel from '@common/helpers/useModel';
import useDateRangeQuery from '@common/helpers/useRangeDateQuery';
import StudentGrades from '@common/models/StudentGrades/StudentGrades';

export default (programGroupId: number) => {
	const { startDate, endDate, startDateTime, endDateTime } = useDateRangeQuery();

	const grades = useModel(
		StudentGrades,
		{
			service_id: store.services.current.id,
			studentId: store.currentStudentId,

			period_start: startDateTime.toISODate(),
			period_end: endDateTime.toISODate(),
		},
		[programGroupId, startDate, endDate, store.currentStudentId],
		{
			disableFetch: true,
		},
	);

	useEffect(() => {
		if (programGroupId) {
			grades.fetch([programGroupId]);
		}
	}, [programGroupId, startDate, endDate, store.currentStudentId]);

	return grades;
};
